




















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Carousel, Slide } from 'vue-carousel';
import axios from 'axios';

type SelectionType = 'collection' | 'type' | 'color' | 'size';

type Selection = { [key in SelectionType]: number };

export interface CollectionConfig {
  name: string;
  img: string;
  types: TypeConfig[];
}

export interface TypeConfig {
  name: string;
  img: string;
  colors: ColorConfig[];
}

export interface ColorConfig {
  color: string;
  products: Product[];
}

export interface Product {
  id: string;
  name: string;
  img: string;
  description: string;
  price: string;
  size: string;
}

export interface SizesConfig {
  label: string;
}

@Component({
  data: () => {
    const selection: Selection = {
      collection: 0,
      type: 0,
      color: 0,
      size: 0
    };
    return {
      collections: [],
      selection
    };
  },
  components: {
    Carousel,
    Slide
  }
})
export default class Configurator extends Vue {
  public collections!: CollectionConfig[];

  public selection!: Selection;

  public mounted() {
    axios
      .get('configurator/config.json')
      .then((v) => {
        this.collections = v.data;
      })
      .catch((v) => {
        // tslint:disable-next-line:no-console
        console.log('Error loading configurator', v);
      });
  }

  public select(group: SelectionType, index: number) {
    switch (group) {
      case 'collection':
        this.selection.type = 0;
      case 'type':
        this.selection.color = 0;
      case 'color':
        this.selection.size = 0;
      case 'size':
        break;
    }
    if (group in this.selection) {
      this.selection[group] = index;
    }
  }

  public calculateStyle(color: ColorConfig) {
    return 'background-color: ' + color.color;
  }

  public calculateWidth(types: TypeConfig[]) {
    return 'width: ' + (100 / types.length) + '%';
  }

  public requireImage(type: string, image: string) {
    return `./configurator/${type}/${image}`;
  }

  get activeCollections(): CollectionConfig[] {
    return this.collections.filter((c) => c.types.some(this.isTypeVisible));
  }

  get types(): TypeConfig[] {
    const collection = this.collections[this.selection.collection];
    if (collection === undefined) {
      return [];
    }
    return collection.types.filter(this.isTypeVisible);
  }

  get colors(): ColorConfig[] {
    const type = this.types[this.selection.type];
    if (type === undefined) {
      return [];
    }
    return type.colors.filter(this.isColorVisible);
  }

  get products(): Product[] {
    const color = this.colors[this.selection.color];
    if (color === undefined) {
      return [];
    }
    return color.products;
  }

  get sizes(): SizesConfig[] {
    return this.products.map((v) => ({
      label: v.size
    }));
  }

  get product(): Product {
    const product = this.products[this.selection.size];
    return product;
  }

  private isTypeVisible(type: TypeConfig) {
    return type.colors.some((c) => this.isColorVisible(c));
  }

  private isColorVisible(color: ColorConfig) {
    return color.products.length > 0;
  }
}
